import styled from '@emotion/styled';

export const StyledText = styled.div(({ theme }) => ({
    display: 'grid',
    gap: theme.spaces[3],
    maxWidth: '40ch',
    lineHeight: theme.lineHeights.base,
}));
